import { useState } from "react";
import execution from "../../assets/execution-overview.png";
import pagetable from "../../assets/table.png";
import detailsexecution from "../../assets/detailsexecution.png";

export function renderAvailability() {
  return <AvailabilityComponent />;
}

function AvailabilityComponent() {
    const [zoomVideo, setZoomVideo] = useState(null);
    const [zoomImage, setZoomImage] = useState(null);

    return (
  <div className=" text-slate-900 dark:text-slate-100 font-body antialiased transition-colors duration-300">

    {/* Main Layout */}
    <div>
      {/* Main Content */}
      <main className="py-10">
        <div className="mx-auto">
          <div className="flex flex-wrap items-center gap-2 mb-6 text-sm">
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Netraa LH</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Product Capabilities</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <span className="text-primary font-medium">Availability</span>
            </div>

          <div className="mb-12">
            <h1 className="text-5xl lg:text-5xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">Availability &amp; Synthetic Execution</h1>
            <p className="text-lg md:text-xl text-slate-600 dark:text-slate-300 leading-relaxed">Understand real-time visibility into performance and behavior through scripted user journeys, ensuring your application delivers consistency across the globe.</p>
          </div>

          {/* Section 5.1 */}
          <section className="mb-16 scroll-mt-24" id="synthetic-execution">
            <h2 className="font-display text-2xl font-bold text-slate-900 dark:text-white mb-4 flex items-center">
              <span className="text-primary mr-3"></span> Synthetic Execution
            </h2>
            <p className="text-slate-600 dark:text-slate-300 mb-6 leading-relaxed">Synthetic execution allows you to simulate user interactions at defined frequencies. This provides a baseline for performance metrics and immediate alerting when critical pathways fail. You can view live journey executions in real-time.</p>

                  <div className="flex items-center justify-center">
<video
  className="w-25 h-45 object-cover object-top cursor-zoom-in"
  autoPlay
  loop
  muted
  playsInline
  onClick={() => setZoomVideo("/videos/synthetic.webm")}
>
  <source src="/videos/synthetic.webm" type="video/webm" />
</video>

</div>

            <p className="text-sm text-slate-500 italic text-center"> Real-time monitoring of scripted journey execution.</p>
          </section>

          {/* Section 5.2 */}
          <section className="mb-16 scroll-mt-24" id="execution-overview">
            <h2 className="font-display text-2xl font-bold text-slate-900 dark:text-white mb-4 flex items-center">
              <span className="text-primary mr-3"></span> Execution Overview
            </h2>
            <p className="text-slate-600 dark:text-slate-300 mb-6 leading-relaxed">The overview panel aggregates data points to give you a high-level summary. Key metrics include execution date/time stamps, geographical location of the synthetic agent, and average response times across all monitored pages.</p>

      <img
        src={execution}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(execution)}
      />

          </section>

          {/* Section 5.3 */}
          <section className="mb-16 scroll-mt-24" id="page-availability">
            <h2 className="font-display text-2xl font-bold text-slate-900 dark:text-white mb-4 flex items-center">
              <span className="text-primary mr-3"></span> Page Availability Details
            </h2>
            <p className="text-slate-600 dark:text-slate-300 mb-6 leading-relaxed">Drill down into specific page performance. This table provides a granular look at each step in the user journey.</p>

            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              <li className="flex items-start gap-3 p-4 rounded-lg bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark">
                <span className="material-symbols-outlined text-primary mt-0.5">timer</span>
                <div>
                  <h4 className="font-bold text-slate-900 dark:text-white text-sm">Avg Response Time</h4>
                  <p className="text-xs text-slate-500 mt-1">Mean time to first byte (TTFB) plus content download.</p>
                </div>
              </li>

              <li className="flex items-start gap-3 p-4 rounded-lg bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark">
                <span className="material-symbols-outlined text-primary mt-0.5">percent</span>
                <div>
                  <h4 className="font-bold text-slate-900 dark:text-white text-sm">Availability %</h4>
                  <p className="text-xs text-slate-500 mt-1">Percentage of successful checks vs total attempts.</p>
                </div>
              </li>

              <li className="flex items-start gap-3 p-4 rounded-lg bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark">
                <span className="material-symbols-outlined text-primary mt-0.5">bar_chart</span>
                <div>
                  <h4 className="font-bold text-slate-900 dark:text-white text-sm">P95 Metrics</h4>
                  <p className="text-xs text-slate-500 mt-1">95th percentile response times to identify outliers.</p>
                </div>
              </li>

              <li className="flex items-start gap-3 p-4 rounded-lg bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark">
                <span className="material-symbols-outlined text-primary mt-0.5">warning</span>
                <div>
                  <h4 className="font-bold text-slate-900 dark:text-white text-sm">Max Response Time</h4>
                  <p className="text-xs text-slate-500 mt-1">The single slowest transaction recorded in the period.</p>
                </div>
              </li>
            </ul>

      <img
        src={pagetable}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(pagetable)}
      />

          </section>

          {/* Section 5.4 */}
          <section className="mb-16 scroll-mt-24" id="detailed-results">
            <h2 className="font-display text-2xl font-bold text-slate-900 dark:text-white mb-4 flex items-center">
              <span className="text-primary mr-3"></span>Execution Details
            </h2>
            <p className="text-slate-600 dark:text-slate-300 mb-6 leading-relaxed">Interactive graphs provide a visual timeline of availability. The "dots-on-graph" visualization represents individual execution points.</p>

            <div className="bg-surface-light dark:bg-surface-dark p-6 rounded-xl border border-border-light dark:border-border-dark mb-6">
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">Feature Deep-Dive</h3>
              <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">Clicking any dot on the availability graph reveals a modal with page-wise behavior, header details, and specific performance trends for that exact moment in time.</p>
              <div className="flex gap-4">
                <div className="flex-1 h-2 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
                  <div className="h-full bg-primary w-3/4" />
                </div>
              </div>
            </div>


      <img
        src={detailsexecution}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(detailsexecution)}
      />

          </section>
          {zoomVideo && (
  <div
    className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
    onClick={() => setZoomVideo(null)}
  >
    <video
      className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-2xl"
      autoPlay
      loop
      muted
      playsInline
      controls
    >
      <source src={zoomVideo} type="video/mp4" />
    </video>
  </div>
)}
{zoomImage && (
  <div
    className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
    onClick={() => setZoomImage(null)}
  >
    <img
      src={zoomImage}
      alt="Zoomed Preview"
      className="max-w-[90vw] max-h-[90vh] rounded-xl shadow-2xl object-contain"
    />
  </div>
)}
        </div>
      </main>
    </div>
  </div>
);
}